import API from "@/api/lib/api";

export const getAllPartyPlatters = async (restaurant_id) => {
  try {
    const response = await API.get(
      `restaurant/${restaurant_id}/party-platters`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSinglePartyPlatter = async (id) => {
  try {
    const response = await API.get(`restaurant/party-platters/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createPartyPlatter = async (data) => {
  try {
    const response = await API.post(`restaurant/party-platters`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updatePartyPlatter = async (id, data) => {
  try {
    const response = await API.put(`restaurant/party-platters/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deletePartyPlatter = async (id) => {
  try {
    const response = await API.delete(`restaurant/party-platters/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
